import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import NumberFormat from "react-number-format";

const InputField = ({ title, handleDataFetch, id, name, url }) => {
  let input = document.getElementById(name);
  let timeout = null;
  input &&
    input.addEventListener("keydown", function (e) {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        handleDataFetch({
          id: id.toString(),
          url: input.value,
        });
      }, 500);
    });

  const success = useSelector((state) => state.singleUser.uploadSuccess);

  useEffect(
    () => {
      if (success && input) {
        input.value = "";
      }
    },
    // eslint-disable-next-line
    [success]
  );

  return (
    <div className="upload-file2">
      <h3>{title}</h3>
      <div>
        <div className="upload-file2-item">
          {id === 7 ? (
            <NumberFormat id={name} thousandSeparator={true} />
          ) : (
            <input id={name} type="text" />
          )}
        </div>
      </div>
    </div>
  );
};

InputField.propTypes = {
  handleDataFetch: PropTypes.func,
  id: PropTypes.number,
  name: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

export default InputField;
